module.exports = __webpack_public_path__ + "static/media/minus-icon.d032248d.svg";